export const stageColors = {
    'L1': '#FF5733',
    'L2': '#33FF57',
    'L3': '#3357FF',
    'L4': '#F1C40F',
    'L5': '#2ECC71',
    'Submitted for L1 Approval': '#3498DB',
    'Submitted for L2 Approval': '#95A5A6',
    'Submitted for L3 Approval': '#A8C9FF', // A light blue for L3 submission
    'Submitted for L4 Approval': '#FFECB3', // A light yellow for L4 submission
    'Submitted for L5 Approval': '#FF9999'
};